import "@fullcalendar/react/dist/vdom"; // necessary for correct rendering order of calendar and plugins

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import HeaderPortal from "src/containers/TableHeader/HeaderPortal";
import TnAOverviewsCalendarWrapper from "./AllEmployeeLeavesViews/AllEmployeeLeavesCalendarWrapper";
import AllEmployeeLeavesTable from "./AllEmployeeLeavesViews/AllEmployeeLeavesTable";
import { ButtonsContainer, Container, ViewOptionButton } from "./styles";

const TnAOverviewsTableCalendarWrapper = () => {
  const tRP = "components.team_presence_and_leaves_all_employee_leaves";

  const { t } = useTranslation();
  const [isCalendarView, setIsCalendarView] = useState<boolean>(false);

  return (
    <Container>
      <HeaderPortal
        title={t(`${tRP}.table_title`)}
        buttonToRender={
          <ButtonsContainer>
            <ViewOptionButton
              variant={"contained"}
              onClick={() => setIsCalendarView(!isCalendarView)}
              size="small"
            >
              {isCalendarView ? t(`${tRP}.table_view`) : t(`${tRP}.calendar_view`)}
            </ViewOptionButton>
          </ButtonsContainer>
        }
      />

      {isCalendarView && <TnAOverviewsCalendarWrapper />}

      {!isCalendarView && <AllEmployeeLeavesTable />}
    </Container>
  );
};

export default TnAOverviewsTableCalendarWrapper;
